import { css } from "@linaria/core";
import React from "react";
import Spinner from "@ui/Spinner";
import Text from "@ui/Text";
import { colors, spacings } from "@ui/Theme";
import t from "../../../../../../../i18n";

const blockLoading = css`
  align-items: center;
  width: 100%;
  min-height: max(60vh, 400px);
  background-color: transparent;
  border-radius: ${spacings.xs};
  color: ${colors.carbon900};
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const blockLoadingSpinner = css`
  height: 54px;
  margin-bottom: ${spacings.m};
  width: 54px;
`;

const blockLoadingText = css`
  color: ${colors.carbon800};
`;

export function BlockLoading() {
  return (
    <div className={blockLoading}>
      <Spinner className={blockLoadingSpinner} />
      <Text type="body1SemiBold">{t("project.dashboard.block.loading.title")}</Text>
      <Text type="body1" className={blockLoadingText}>
        {t("project.dashboard.block.loading.text")}
      </Text>
    </div>
  );
}
